import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GlobalState {
  phoneUser?: any;      // your phone login user details
  msUser?: any;         // optional: Microsoft user details
  settings?: any;       // app settings
  preferences?: any;    // UI preferences
  [key: string]: any;   // allow adding other data types
}

const initialState: GlobalState = {
  phoneUser: null,
  msUser: null,
  settings: {},
  preferences: {},
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setGlobalData: (state, action: PayloadAction<{ key: string; value: any }>) => {
      state[action.payload.key] = action.payload.value;
    },
    clearGlobalKey: (state, action: PayloadAction<string>) => {
      state[action.payload] = null;
    },
    resetGlobal: () => initialState,
  },
});

export const { setGlobalData, clearGlobalKey, resetGlobal } = globalSlice.actions;
export default globalSlice.reducer;